import { render } from "./Tichete.vue?vue&type=template&id=e379bea8&ts=true"
import script from "./Tichete.vue?vue&type=script&lang=ts"
export * from "./Tichete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__